import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { DropDown } from 'src/app/interfaces/drop-down.interface';

@Component({
  selector: 'app-view-model-checkbox-list',
  template: `
    <mat-label>{{ label | translate }}</mat-label>
    <div [formGroup]="form" class="grid grid-cols-auto-fill-64 gap-x-3.5 pl-3.5">
      <mat-checkbox *ngFor="let option of options" [formControlName]="option.value" (change)="onCheckboxClick(option.value)">
        {{ option.text | translate }}
      </mat-checkbox>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ViewModelCheckboxListComponent),
      multi: true,
    },
  ],
  styles: [
    `
      mat-label {
        color: gray;
      }
    `,
  ],
})
export class ViewModelCheckboxListComponent implements ControlValueAccessor {
  private _options: DropDown<string>[] = [];
  public get options(): DropDown<string>[] {
    return this._options;
  }
  @Input() public label: string = '';

  @Input() public set options(value: DropDown<string>[]) {
    this._options = value;
    this.createControls(value);
  }

  form: FormGroup = new FormGroup({});

  private createControls(value: DropDown<string>[]) {
    //create form controls for each option unless they already exist
    value?.forEach((option) => {
      if (!this.form.contains(option.value)) {
        this.form.addControl(option.value, new FormControl(false));
      }
    });
  }

  writeValue(obj: any): void {
    if (obj) {
      Object.keys(obj).forEach((key) => {
        //remove and re-add control to update the initial value
        if (this.form.contains(key)) {
          //set value
          this.form.get(key).setValue(obj[key]);
        }
      });
    }
  }

  registerOnChange(fn: any): void {
    this.form.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.form.disable() : this.form.enable();
  }

  @Output() checkboxChanged = new EventEmitter<{ key: string; value: boolean }>();
  onCheckboxClick(key: string) {
    const value = this.form.get(key)?.value;
    this.checkboxChanged.emit({ key, value });
  }
}
